// extracted by mini-css-extract-plugin
export default {"toggleBox":"toggle-box_toggleBox__tzf5D","active":"toggle-box_active__1IQGg"};